import { useMemo } from "react";
import { translateDescription } from "./helper";
import { Trans } from "react-i18next";
import * as S from "./styles";
import type { AutomationConfig } from "@smartsuite/automation-engine-api";
import { ShowMoreWrapper } from "../ShowMoreWrapper";

export const PhraseBuilder: React.FC<{ automation: AutomationConfig }> = ({
  automation,
}) => {
  const description = useMemo(() => {
    return translateDescription(
      automation.automaticDescription,
      automation.timezone ?? "UTC",
    ).replace(emptySpacesWithCommaRegex, "");
  }, [automation.automaticDescription]);

  return (
    <S.Root>
      <ShowMoreWrapper>
        <Trans>{description}</Trans>
      </ShowMoreWrapper>
    </S.Root>
  );
};

const emptySpacesWithCommaRegex = /,[ ]{2,}/gm;
